export const PROTOCOL_ITEM_ADD_ISSUE_QA = 'protocol-item-add-issue';
